// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { Flex, Layout } from 'antd';
import { useEffect } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { Route, Routes, useSearchParams } from 'react-router-dom';
import BlueHexAnimation from '../../assets/svg/blueHexAnimation.svg';
import { PlatformProvider } from '../../context/platform/PlatformContextProvider';
import AccountPage from '../../pages/account/AccountPage';
import EnrollPage from '../../pages/enroll/EnrollPage';
import LandingPage from '../../pages/landing/LandingPage';
import LaunchPage from '../../pages/launch/LaunchPage';
import { preloadSvg } from '../../utils/SvgPreloader';
import CustomerNameComponent from '../customer/CustomerNameComponent';
import { ErrorComponent } from '../error/ErrorComponent';
import './App.less';
import { Content, Header } from 'antd/lib/layout/layout';
import ConsentPage from '../../pages/consent/ConsentPage';
import PhoneVerificationPage from '../../pages/phone-verification/PhoneVerificationPage';
import VerifyPage from '../../pages/verify/VerifyPage';
const App = () => {
  // Preload critical SVGs early in the app lifecycle
  useEffect(() => {
    // Preload the loading animation SVG as it's used frequently
    preloadSvg(BlueHexAnimation).catch((error) => {
      console.warn('Failed to preload loading animation SVG:', error);
    });
  }, []);
  const [searchParams] = useSearchParams();
  const handleError = ({ error }: FallbackProps) => {
    return <ErrorComponent cause={error.message} />;
  };
  return (
    <PlatformProvider>
      <Layout className="app-layout">
        <Header>
          <CustomerNameComponent />
        </Header>
        <Content className="app-body-flex-container">
          <Flex align="center" justify="center" vertical>
            <ErrorBoundary fallbackRender={handleError}>
              <Routes>
                <Route path={'/'} element={<LandingPage />} />
                <Route path={'/launch'} element={<LaunchPage />} />
                <Route path={'/account'} element={<AccountPage />} />
                <Route path={'/enroll'} element={<EnrollPage />} />
                <Route path={'/consent'} element={<ConsentPage />} />
                <Route path={'/phone-verification'} element={<PhoneVerificationPage />} />
                <Route path={'/verify'} element={<VerifyPage />} />
                <Route path={'*'} element={<ErrorComponent cause={ searchParams.get('error-code') ?? "not-found"} />} />
              </Routes>
            </ErrorBoundary>
          </Flex>
        </Content>
      </Layout>
    </PlatformProvider>
  );
};
export default App;
